"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Close_1 = __importDefault(require("../Icon/icons/Close"));
var StyledModalClose = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  ", "\n\n  ", "\n"], ["\n  cursor: pointer;\n  ", "\n\n  ", "\n"])), function (props) {
    return props.$minimal
        ? "\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        "
        : "\n        position: relative;\n        top: -15px;\n        right: -15px;\n  ";
}, function (props) {
    return props.$outside &&
        "\n    align-items: center;\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    position: absolute;\n    right: -5px;\n    top: -40px;\n    width: 40px;\n  ";
});
var ModalClose = function (_a) {
    var closeOutside = _a.closeOutside, _b = _a.color, color = _b === void 0 ? 'BRAND_BLACK' : _b, minimal = _a.minimal, onClick = _a.onClick;
    return (React.createElement(StyledModalClose, { onClick: onClick, "$minimal": minimal, "$outside": closeOutside },
        React.createElement(Close_1.default, { color: color })));
};
exports.default = ModalClose;
var templateObject_1;
